<script>
/**
 * ****************************************************************************
 * @description     :   Select Component Search
 * @created at      :   2023/09/11
 * @created by      :   ANS897 – hieunm@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash';
import uuid from 'lodash-uuid';
import { mapMutations } from 'vuex';

import SamplePopupSearch from '@/views/popup/samplePopupSearch';
import gs0520i_project from '@/views/popup/gs0520iProject';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of select component
 */
var AnsSelectSearch = {
    template: template,
    components: {
        SamplePopupSearch,
        gs0520i_project
    },
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        emptyText: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        buttonClass: String,
        pageSearch: String,
        isSecondPopup: Boolean,
        initData: Object,
        size: String,
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        isModalHeader: {
            type: Boolean,
            default: true
        },
        removeEmptyOption: Boolean,
        options: Array,
        onChangeEvent: Function,
        onChange: Function,
        onFocus: Function,
        onBlur: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: uuid.uuid(),
            show: false,
            popup: ''
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
    },
    unmounted() {
        this.hidePopup();
    },
    computed: {
        vewValue() {
            const val = this.modelValue ? this.modelValue : this.value;
            return val;
        },
        listOptions() {
            if (this.removeEmptyOption) {
                return this.options ?? [];
            }
            if (!this.options) {
                return [
                    {
                        code: '',
                        name: ''
                    }
                ];
            }
            const idx = _.findIndex(this.options, function (o) {
                return (
                    o.name === '' || o.name === 'すべて' || o.name === '全て'
                );
            });
            if (idx < 0) {
                this.options.unshift({
                    code: '',
                    name: ''
                });
            }
            return this.options ?? [];
        },
        modalTitle() {
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'gs0520i_project':
                    return '検索';
                default:
                    return '検索画面';
            }
        }
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError']),
        showPopup() {
            this.show = true;
            this.popup = this.pageSearch;
            this.hideHeaderError();
        },
        hidePopup() {
            this.show = false;
            this.hideHeaderError();
        },
        /**
         * event forcus on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * click update item for select element
         * -----------------------------------------
         * @author : HieuNM - 2023/09/12 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(item);
            }
        },
        onChangeInput(e) {
            const newValue = this.$refs.select.value;
            if ((this.vewValue ?? '') != (newValue ?? '')) {
                this.$emit('update:modelValue', newValue);
                if (this.onChangeEvent) {
                    this.onChangeEvent(e, newValue);
                }
            }
        }
    }
};
export default AnsSelectSearch;
</script>
